import React, { FC } from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router';
import { ProductGroupOverview } from './productgroups/overview/ProductGroupOverview';
import { ProductGroupDetail } from './productgroups/detail/ProductGroupDetail';
import { SortingView } from './productgroups/sorting/SortingView';
import { useEnvironment } from '../../shared/components/EnvironmentContext';
import { ENVIRONMENT_DEMO } from '../../constants';
import { ProductSelectionProvider } from '../../shared/product-selection/ProductSelectionContext';

const MerchandisingRouteSwitch: FC = () => {
    const { path, url } = useRouteMatch();
    // CatMan is not available in the demo environment
    const libraryManagedProductGroupsEnabled = useEnvironment() !== ENVIRONMENT_DEMO;

    return (
        <Switch>
            {libraryManagedProductGroupsEnabled ? (
                <Route exact path={`${path}/productgroups`}>
                    <ProductGroupOverview />
                </Route>
            ) : null}
            {libraryManagedProductGroupsEnabled ? (
                <Route exact path={`${path}/productgroups/:productGroupId`}>
                    <ProductSelectionProvider>
                        <ProductGroupDetail />
                    </ProductSelectionProvider>
                </Route>
            ) : null}
            {libraryManagedProductGroupsEnabled ? (
                <Route exact path={`${path}/productgroups/:productGroupId/sorting`}>
                    <SortingView />
                </Route>
            ) : null}
            {libraryManagedProductGroupsEnabled ? (
                <Route exact path={path}>
                    <Redirect to={`${url}/productgroups`} />
                </Route>
            ) : null}
            <Route>
                <Redirect to="/catalogue" />
            </Route>
        </Switch>
    );
};

export default MerchandisingRouteSwitch;
